import { render, staticRenderFns } from "./emoji-selector.vue?vue&type=template&id=c11b79da&scoped=true&"
import script from "./emoji-selector.vue?vue&type=script&lang=js&"
export * from "./emoji-selector.vue?vue&type=script&lang=js&"
import style0 from "./emoji-selector.vue?vue&type=style&index=0&id=c11b79da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11b79da",
  null
  
)

export default component.exports